<template>
  <div class="tab-all">
    <n-divide class="table-tools">
      <div class="search">
        <n-input placeholder="Поиск" v-bind="$form.input('title')" />
        <n-button @click="filterLoad">Поиск</n-button>
      </div>
      <n-button @click="() => this.$var('add', true)">Добавить документ</n-button>
    </n-divide>
    
    <n-table :data="data" :columns="columns" :loading="$var('load')">
      <template #type="{item}">
        <span v-if="item.type">
          {{ item.type.title }}
        </span>
      </template>
      <template #download="{item}">
        <a href="" :download="item.file.src">Скачать</a>
      </template>
      <template #tools="{item}">
        <n-button icon="eye" flat round @click="pushTo(item.file.src)" />
      </template>
    </n-table>

    <modal-add v-if="$var('add')" :project="project" @submit="change" @close="$var('add', false)" />
    <modal-edit v-if="$var('edit')" :document-id="$var('edit')" :project="project" @submit="change" @close="$var('edit', false)" />
  </div>
</template>

<script>
import ModalAdd from './ModalAdd'
import ModalEdit from './ModalEdit'

export default {
  name: 'TabAll',
  components: { ModalEdit, ModalAdd, },
  props: [ 'project', ],
  data() {
    return {
      data: [],
      columns: [
        { name: 'type', title: 'Документ', },
        { name: 'file.name', title: 'Название', },
        { name: 'download', title: '', },
        { name: 'tools', title: '', },
      ],
      title: '',
    }
  },
  watch: {
    showAll() {
      this.$nextTick(() => {
        this.load()
      })
    },
  },
  mounted() {
    this.load()
  },
  created() {
    this.$form.init({
      title: '',
    })
  },
  methods: {
    pushTo(path) {
      const a = document.createElement('a')
      a.href = path
      a.target = '_blank'
      a.click()
    },
    load() {
      this.$var('load', true)
      $api.iq.documents.getByProject(this.project.id).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    filterLoad() {
      this.$var('load', true)
      $api.iq.documents.getByProject(this.project.id).filter({ title: 'search:'+this.$form.get('title'), }).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    change() {
      setTimeout(() => {
        this.load()
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
  .tab-all {
  
  }
  .table-tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .search {
      display: flex;
      align-items: center;
      .n-input {
        margin-right: 25px;
      }
    }
    .n-input {
      max-width: 150px;
    }
  }
</style>
